import { useEffect } from 'react'
import { showToast } from 'shared/ui/Toast/lib/showToast'
import { logger } from 'shared/lib'
import { type IResponseEventRegisterOrganizationError } from 'entities/Auth/api/types'
import { WebsocketEvent } from 'entities/WebSocket'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type RegisterMultiorgStore } from 'pages/register/pages/registerMultiorg/ui/RegisterMultiorg'

export const useEventRegisterOrganizationError = (store: RegisterMultiorgStore) => {
  const { websocket } = useEntitiesContext()
  const handler = (data: IResponseEventRegisterOrganizationError) => {
    if (store) {
      showToast({
        type: 'error',
        title: data.error_message,
      })
      store.setLoading(false)
    }
    logger.error(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.RegisterOrganizationError, handler), [])
}
